export function truncate(text, threshold, ext) {
    if (threshold === void 0) { threshold = 42; }
    if (ext === void 0) { ext = '...'; }
    if (text.length > threshold) {
        return "".concat(text.slice(0, threshold)).concat(ext);
    }
    return text;
}
